var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
        [
          _c(
            "div",
            {
              staticClass: "modal-content",
              staticStyle: { height: "calc(100vh - 50px)" },
            },
            [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("Select attributes"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.searchPhrase,
                            expression: "searchPhrase",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "search", placeholder: "Search..." },
                        domProps: { value: _vm.searchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchPhrase = $event.target.value.trim()
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "mt-3",
                        staticStyle: {
                          "max-height": "calc(100vh - 280px)",
                          "overflow-y": "auto",
                        },
                      },
                      _vm._l(_vm.sectionsView, function (s) {
                        return _c(
                          "div",
                          { key: s.Name },
                          [
                            _c("h6", { staticClass: "mt-3 mb-1" }, [
                              _vm._v(_vm._s(s.Name)),
                            ]),
                            _vm._v(" "),
                            _vm._l(s.attributesView, function (attr) {
                              return _c("div", { key: attr.AttributeId }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return attr.toggleSelect()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-lg",
                                      class: {
                                        "fa-square-check": attr.IsSelected,
                                        "fa-square": !attr.IsSelected,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { attrs: { title: attr.Name } },
                                      [_vm._v(_vm._s(attr.NameEllipsis))]
                                    ),
                                  ]
                                ),
                              ])
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("h5", [
                      _vm._v(
                        "Selected attributes (" +
                          _vm._s(_vm.selectedAttributes.length) +
                          "):"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "max-height": "calc(100vh - 280px)",
                          "overflow-y": "auto",
                        },
                      },
                      _vm._l(_vm.selectedAttributes, function (attr) {
                        return _c(
                          "div",
                          {
                            key: attr.AttributeId,
                            staticClass: "p-2 bg-secondary m-2 text-white",
                          },
                          [
                            _c("span", { attrs: { title: attr.Name } }, [
                              _vm._v(_vm._s(attr.NameEllipsis)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "p-0 border-0 text-white",
                                staticStyle: {
                                  "background-color": "transparent",
                                  "font-size": "1.3rem",
                                  float: "right",
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return attr.toggleSelect()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        ×\n                                    "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.save },
                  },
                  [_vm._v("Save & Close")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("Cancel")]
                ),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }